var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.16675L8.0755 8.55041C8.63533 8.92364 9.36467 8.92364 9.9245 8.55041L16.5 4.16675M3.16667 13.3334H14.8333C15.7538 13.3334 16.5 12.5872 16.5 11.6667V3.33341C16.5 2.41294 15.7538 1.66675 14.8333 1.66675H3.16667C2.24619 1.66675 1.5 2.41294 1.5 3.33341V11.6667C1.5 12.5872 2.24619 13.3334 3.16667 13.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.90393572a4bfd98edfe907ada8c317ce.svg";
export { ForwardRef as ReactComponent };